import { Box, Center, Text, VStack, useToast } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import QrReader from "react-web-qr-reader";
import { useAuth } from "../../plugins/CookieAuthPlugin";
import { toAbsoluteUrl, toastGenerator } from "../../utils/helper";
import { translation } from "./translation";

export default function ScanQRCode() {
   const isEn = JSON.parse(localStorage.getItem("isEn")) || false;
   const history = useHistory();
   const { user, logout } = useAuth();
   const text = translation(isEn);
   const [data, setData] = useState("");
   const { pathname } = useLocation();
   const parentUrl = `/${pathname.split("/")[1]}`;
   const toast = useToast();

   const previewStyle = {
      height: 240,
      width: 320
   };
   const handleScan = (result) => {
      if (result) {
         const isValid = result.data.includes("visit-angkor");
         if (isValid) {
            const code = result.data.split("/");
            setData(result.data);
            history.push(`${parentUrl}/${code[code.length - 1]}`);
         } else {
            setData("");
            toast(toastGenerator({
               status: "error",
               message: text.notFound,
            })
            );
         }
      }
   };

   useEffect(() => {
      if (user) logout();
   }, [user, logout]);

   return (
      <Center h="95vh" bgColor="blue.50" bg={`url(${toAbsoluteUrl("/assets/white-bg.svg")}) center / cover no-repeat`}>
         <VStack overflow="hidden" w={{ xl: "30vw", lg: "40vw", md: "50vw", sm: "98vw", base: "98vw" }} h="100%" px={{ base: "5px", sm: "10px" }} justifyContent="center">
            <Center fontSize="170%" fontFamily="moul" textAlign="center" color="red.900" mb="5">
               {text.headerTitle.on} <br /> {text.headerTitle.un}
            </Center>
            <Box h="50%">
               <QrReader delay={800} style={previewStyle} onScan={handleScan} />
            </Box>
            {data === "" && (
               <Text fontSize="140%" color="red.900" fontFamily="moul">
                  {text.pleaseScan}
               </Text>
            )}
         </VStack>
      </Center>
   );
}
